import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { useRemoveLineItem } from "@babackapp/return-widget-components/hooks/use-remove-line-item";
import { useReturnableItems } from "@babackapp/return-widget-components/hooks/use-returnable-items";
import { useReturnableQuantity } from "@babackapp/return-widget-components/hooks/use-returnable-quantity";
import { useUpdateLineItem } from "@babackapp/return-widget-components/hooks/use-update-line-item";
import { useNavigate, useParams } from "react-router-dom";
import { useWidgetParams } from "./use-widget-params";

export function useLineItemLayout() {
  const { lineItemId = "" } = useParams<{ lineItemId: string }>();
  const { orderId, shopSlug, shopId } = useWidgetParams();
  const navigate = useNavigate();
  const returnableItems = useReturnableItems(orderId, shopSlug);
  const draft = useDraftReturn(orderId);
  const updateLineItem = useUpdateLineItem(orderId);
  const removeLineItem = useRemoveLineItem(orderId);

  const lineItem = returnableItems.find((li) => li.line_item_id === lineItemId);
  const draftItem = draft?.lineItems.find((li) => li.lineItemId === lineItemId);
  const quantity = draftItem?.quantity ?? 1;
  const returnableQty = useReturnableQuantity(lineItem, { orderId, shopSlug });

  const setQuantity = (value: number) => {
    if (!lineItemId) return;
    updateLineItem(lineItemId, { quantity: value });
  };

  const removeItem = () => {
    removeLineItem(lineItemId);
    navigate(`/return-widget/${shopId}/order/${orderId}/line-item`);
  };

  return {
    lineItem,
    quantity,
    setQuantity,
    returnableQty,
    lineItemId,
    removeItem,
  };
}
